<template>
  <div>
    <div class="member-main-tab">
      <ul class="main-tab">
        <li :class="{ active: tabIndex === 0 }" @click="changeTab(0)">
          未回答
        </li>
        <li :class="{ active: tabIndex === 1 }" @click="changeTab(1)">
          已回答
        </li>
        <li :class="{ active: tabIndex === 2 }" @click="changeTab(2)">
          待详解
        </li>
        <li :class="{ active: tabIndex === 3 }" @click="changeTab(3)">
          已追问
        </li>
      </ul>
      <div class="query-box">
        <div class="query-input">
          <Input
            v-model="searchQId"
            @on-change="filterNumber"
            placeholder="请输入问题ID"
          />
        </div>
        <div class="query-input">
          <Input v-model="searchCourseId" placeholder="请输入课程ID" />
        </div>
        <div class="query-button">
          <Button type="primary" @click="search">查询</Button>
        </div>
      </div>
    </div>
    <div class="member-main-body">
      <div class="main-header"></div>
      <div class="main-table scroll-top">
        <table>
          <thead>
            <tr>
              <th style="width: 120px">时间</th>
              <th>&nbsp;</th>
              <th class="center" style="width: 90px">操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in dataList" :key="index">
              <td>{{ item.qTime }}</td>
              <td class="question-num">共有提问：{{ item.count }}</td>
              <td class="center">
                <Button
                  type="primary"
                  :to="{
                    name: 'AnswerCourse',
                    query: { t: tabIndex, d: item.qTime },
                  }"
                  style="width: 70px; height: 28px; line-height: 28px"
                  shape="circle"
                  >查 看</Button
                >
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="page" v-show="totalCount > pageSize">
        <Page
          :total="totalCount"
          :current="pageIndex"
          :page-size="pageSize"
          @on-change="changePage"
          show-elevator
          show-total
        />
      </div>
    </div>
  </div>
</template>

<script>
import { siteMixin } from "../../utils/mixin";
import { user } from "../../request";
export default {
  mixins: [siteMixin],
  data() {
    return {
      tabIndex: 0,
      searchQId: "",
      searchCourseId: "",
      query: {
        agencyId: -1,
        page: 1,
        isResolved: 0, //是否回答
        isReport: 0, //是否待详解
        isComment: 0, //是否有追问
        courseIds: "",
      },
      dataList: [],
      pageIndex: 1,
      pageSize: 15,
      totalCount: 0,
    };
  },
  watch: {
    userCourseList() {
      if (this.siteConfig.agencyId == 0 && this.userCourseList.length > 0) {
        this.initQueryData();
        this.getData();
      }
    },
  },
  mounted() {
    this.setMetaData("我的答疑");
    this.initQueryData();
    this.getData();
  },
  methods: {
    initQueryData() {
      this.query.agencyId =
        this.siteConfig.agencyId > 0 ? this.siteConfig.agencyId : -1;
      this.query.isResolved = this.tabIndex == 0 ? 0 : 1;
      this.query.isReport = this.tabIndex == 2 ? 1 : 0;
      this.query.isComment = this.tabIndex == 3 ? 1 : 0;
      this.query.userId = this.loginUser.userId;
      if (this.siteConfig.agencyId == 0 && this.loginUser.ugid == 5) {
        let courseIds = "";
        this.userCourseList.forEach((item) => {
          if (courseIds) courseIds += ",";
          courseIds += item.courseId;
        });
        this.query.courseIds = courseIds;
      }
      this.query.userId = this.loginUser.userId;
    },
    getData() {
      if (this.siteConfig.agencyId == 0 && this.loginUser.ugid == 5 && !this.query.courseIds) return;
      user.getQuestionListWithDate(this.query).then((res) => {
        //console.log("dateQuestionList", res);
        if (res.status === 1) {
          this.dataList = res.data.list;
          this.totalCount = res.data.total;
        }
      });
    },
    changePage(page) {
      this.query.page = this.pageIndex = page;
      this.getData();
    },
    filterNumber() {
      const value = this.searchQId.replace(/[^\d]/g, "");
      this.$nextTick(() => {
        this.searchQId = value;
      });
    },
    search() {
      if (!this.searchQId && !this.searchCourseId) return;
      this.$router.push({
        name: "AnswerList",
        query: { cid: this.searchCourseId, qid: this.searchQId },
      });
    },
    changeTab(index) {
      if (this.tabIndex == index) return false;
      this.tabIndex = index;
      this.initQueryData();
      this.getData();
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/var.less";
@import "../../assets/css/member-main.less";
.query-box {
  margin-top: 1.5rem;
  .query-input {
    width: 100px;
    margin-right: 1rem;
    .inline-block();
  }
  .query-button {
    margin-right: 1rem;
    .inline-block();
  }
}
.page {
  padding: 30px 0;
  text-align: center;
}
</style>